import { useDispatch, useSelector } from "react-redux";
import { API_URL } from "../../configs/_api";
import ApiRequest from "../../utils/apiRequest";
import {
    // setData,
    fetchingData,
    fetchDataSuccess,
    fetchDataFail,

    // Create
    submittingData,
    submitDataSuccess,
    submitDataFail,
    reloadDialogState,

    setCurrentPage,
    setSearchTerm,
    setRowsPerPage,

} from "./_reducers";
import { useNoti } from "../../providers";

const useProductBrandActions = () => {
    const dispatch = useDispatch();
    const { showNoti } = useNoti();

    const currentPage = useSelector(state => state.productBrand.currentPage);
    const rowsPerPage = useSelector(state => state.productBrand.rowsPerPage);
    const searchTerm = useSelector(state => state.productBrand.searchTerm);

    function getAllProductBrandList() {
        dispatch(fetchingData());

        let getProductBrandUrl = `${API_URL.ProductBrand}/list?search_term=${searchTerm}&page_no=${currentPage+1}&page_size=${rowsPerPage}`;

        ApiRequest.get(getProductBrandUrl).then(res => {
            const data = res.data.payload.data;
            const { total_items } = res.data.payload.metadata;
            dispatch(fetchDataSuccess({ data, total_items }));
        }).catch(err => {
            dispatch(fetchDataFail(err.response?.data));
        });
    }

    async function createProductBrand(data) {
        dispatch(submittingData());
        try {
            const url = API_URL.ProductBrand;
            const res = await ApiRequest.post(url, data);

            showNoti('Product Brand created!', 'success');
            dispatch(submitDataSuccess());
            getAllProductBrandList();
            return res.data.payload.data;
        }
        catch (err) {
            const errorMessage = err.response.data.errors.message;
            dispatch(submitDataFail(errorMessage ?? 'Creating Product Brand is Failed'));
            showNoti(errorMessage, 'error');

            const errors = {};
            errors.data = err.response?.data.errors.data;
            return Promise.reject(errors);
        }
    }

    async function updateProductBrand(data) {
        dispatch(submittingData());
        try {
            const url = `${API_URL.ProductBrand}/edit`;
            const res = await ApiRequest.post(url, data);

            dispatch(submitDataSuccess());
            return res.data.payload.data;
        } catch (err) {
            const errorMessage = err.response.data.errors.message;
            dispatch(submitDataFail(errorMessage ?? 'Updating Product Brand is Failed'));
            showNoti(errorMessage, 'error');

            const errors = {};
            errors.data = err.response?.data.errors.data;
            return Promise.reject(errors);
        }
    }

    async function deleteProductBrand(id) {
        dispatch(submittingData());

        const url = `${API_URL.ProductBrand}/${id}`;
        try {
            await ApiRequest.delete(url);
        } catch (err) {
            console.error(err);
            const errMsg = `Failed to delete brand! ${err.message}`;
            dispatch(fetchDataFail(errMsg));
            return Promise.reject();
        }
    }

    function refreshDialogState() {
        dispatch(reloadDialogState());
    }

    function changeSearchTerm(search_key) {
        dispatch(setCurrentPage(0));
        dispatch(setSearchTerm(search_key));
    }

    function changeCurrentPage(pageNo) {
        dispatch(setCurrentPage(pageNo));
    }

    function changeRowsPerPage(rowsPerPage) {
        dispatch(setCurrentPage(0));
        dispatch(setRowsPerPage(rowsPerPage));
    }


    return {
        // Actions
        getAllProductBrandList,
        createProductBrand,
        updateProductBrand,
        deleteProductBrand,
        refreshDialogState,

        // Paganation
        changeSearchTerm,
        changeCurrentPage,
        changeRowsPerPage,
    }
}

export default useProductBrandActions;